import React from 'react';
import { motion } from 'framer-motion';
import quickpayImage from '../recursos/Cajero-quickpaymini-papeleria2.png';
import '../estilos/conexionEmpatica.css';
import { useHistory } from 'react-router-dom';

const ConexionEmpatica = () => {
    const history = useHistory();

    const handleButtonClick = () => {
        history.push('/ApiReference');
    };

    return (
        <motion.section
            id="herramientas para desarrollador"
            className="fondo text-gray-800 rounded-lg shadow-lg min-h-screen overflow-x-hidden"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
        >
            {/* Contenedor alineado para todos los tamaños */}
            <div className="w-full px-4 sm:px-6 lg:px-8 mb-2 mt-6 ml-[5%] sm:ml-[10%] md:ml-[15%] lg:ml-[21%]">
                <motion.h3
                    className="text-md sm:text-xl md:text-2xl font-sans text-left text-black mb-1"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1, duration: 0.5 }}
                >
                    Herramientas para desarrolladores
                </motion.h3>

                <motion.div
                    className="w-[50%] sm:w-[40%] md:w-[30%] lg:w-[27%] h-0.5 bg-blue-900"
                    initial={{ opacity: 0, scaleX: 0 }}
                    whileInView={{ opacity: 1, scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2, duration: 0.5, ease: "easeOut" }}
                />
            </div>

            {/* TÍTULO2 - Versión responsiva */}
            <motion.h2
                className="w-full text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center text-blue-900 mb-8 sm:mb-10 md:mb-14 mt-2 sm:mt-3 lg:mt-4 px-4 sm:px-6 lg:px-8 max-md:break-words"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3, duration: 0.6 }}
            >
                Compatibilidad con sistemas POS
            </motion.h2>

            <div className="flex flex-col lg:flex-row items-center justify-between gap-8 sm:gap-10 lg:gap-12 max-md:gap-6">
                {/* IMAGEN */}
                <motion.div
                    className="w-full lg:w-1/2 flex justify-center lg:justify-start max-md:px-4"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                >
                    <div className="cajeroMargen overflow-hidden mb-6 lg:mb-0 max-md:mb-8 max-md:w-full ">
                        <img
                            src={quickpayImage}
                            alt="Quickpaymini"
                            className="w-full h-auto object-cover"
                        />
                    </div>
                </motion.div>

                {/* TEXTO Y BOTÓN */}
                <motion.div
                    className="w-full lg:w-1/2 space-y-6 sm:mt-8 lg:mt-10 max-md:max-w-full px-4 sm:px-6 lg:px-8 max-md:flex-grow"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.7, duration: 0.8 }}
                >
                    <div className="space-y-6 max-md:space-y-8">
                        <p className="text-justify text-sm sm:text-base md:text-lg lg:text-xl textcontent break-words max-md:leading-relaxed max-md:hyphens-auto">
                            En Empatica hemos logrado conectar de forma <span className="font-semibold">segura y confiable</span> con puntos de venta como <span className="font-semibold">Sicar, Aspel SAE, Microsip, Softrestaurant y POS Empatica,</span> permitiendo una integración que automatiza pagos, cortes de caja y procesos de facturación. Esta conexión mejora la eficiencia operativa del negocio y brinda <span className="font-semibold">una experiencia más fluida tanto para el equipo como para los clientes.</span>
                        </p>

                        <p className="text-justify text-sm sm:text-base md:text-lg lg:text-xl textcontent break-words max-md:leading-relaxed max-md:hyphens-auto">
                            En caso de contar con un sistema de punto de venta distinto, el cliente podrá acceder a nuestra <span className="font-semibold">API</span> de conexión a través del siguiente enlace.
                            Desde ahí, podrá consultar la documentación técnica necesaria para <span className="font-semibold">integrar Quickpaymini de manera personalizada</span> a su sistema actual.
                        </p>
                    </div>

                    {/* BOTÓN */}
                    {/* BOTONES */}
<motion.div
    className="mt-8 pb-12 ml-3 max-md:ml-0 max-md:mt-10 max-md:pb-8 flex flex-wrap gap-4 max-md:flex-col"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ delay: 1.0, duration: 0.5 }}
    style={{ overflow: 'visible' }}
>
    {/* API */}
    <motion.a
        whileHover={{
            scale: 1.07,
            transition: {
                type: 'spring',
                stiffness: 400
            }
        }}
        whileTap={{ scale: 0.95 }}
        href="/ApiReference"
        target="_blank"
        rel="noopener noreferrer"
        className="
            inline-flex
            items-center
            justify-center
            bg-gradient-to-l
            from-[#2D4E86]
            to-[#29ABE2]
            text-white
            py-3
            px-7
            rounded-full
            text-base
            lg:text-lg
            font-medium
            transition-colors
            border-2
            border-sky-500
            max-md:w-full
        "
        style={{
            transformOrigin: 'center',
            zIndex: 10
        }}
    >
        Conoce API de Conexión
    </motion.a>

    {/* SIMULADOR */}
    <motion.button
        type="button"
        whileHover={{
            scale: 1.07,
            transition: {
                type: 'spring',
                stiffness: 400
            }
        }}
        whileTap={{ scale: 0.95 }}
        onClick={() =>
            history.push('/cajeros/simulador')
        }
        className="
            inline-flex
            items-center
            justify-center
            bg-white
            text-[#2D4E86]
            py-3
            px-7
            rounded-full
            text-base
            lg:text-lg
            font-semibold
            transition-all
            border-2
            border-[#29ABE2]
            hover:bg-[#EFF8FF]
            max-md:w-full
        "
    >
        Prueba nuestro simulador
    </motion.button>
</motion.div>
                </motion.div>
            </div>
        </motion.section>
    );
};

export default ConexionEmpatica;
